import { useEffect, useState } from 'react';
import { useContext } from 'react';
import { useRef } from 'react';
import { Outlet, Link, useNavigate } from "react-router-dom";

import Offcanvas from 'react-bootstrap/Offcanvas';
import NavigationMenu from "../components/NavigationMenu"
import BrandsFilter from "../components/BrandsFilter"
import Navbar from 'react-bootstrap/Navbar';
import InputGroup from 'react-bootstrap/InputGroup';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import { RiSearchLine, RiMenu4Fill } from "react-icons/ri";
import marcaService from "../services/marcaService";
import { SearchContext } from '../context/SearchContext';
import { useAuth } from '../context/AuthContext';
import LoginModal from '../components/LoginModal';
import Filters from '../components/Filters';

const Layout = ({ filterData }) => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const [allOptions, setAllOptions] = useState([]); 
  const [optionsFilter, setOptionsFilter] = useState([]); 
  const [showMenu, setShowMenu] = useState(false);
  const { setSearchText } = useContext(SearchContext);

  const typeaheadRef = useRef();

  const handleCloseMenu = () => setShowMenu(false);
  const handleShowMenu = () => setShowMenu(true);

  useEffect(() => {
    const loadBrands = async () => {
      try {
        setIsLoading(true);
        const makers = await marcaService.getMakers();
        // Incluir marcas y modelos como opciones del buscador
        const options = [];
        makers.forEach(maker => {
          options.push({ name: maker.name });
          (maker.models || []).forEach(model => {
            options.push({ name: model.name });
          });
        });
        // Eliminar duplicados por nombre
        const unique = Array.from(new Map(options.map(o => [o.name, o])).values());
        setAllOptions(unique);
        setOptionsFilter(unique);
      } catch (err) {
        console.error('Error al cargar marcas', err);
      } finally {
        setIsLoading(false);
      }
    };

    loadBrands();
  }, []);

  const onSearching = (query) => {
    const filtered = allOptions.filter((brand) =>
      brand.name.toLowerCase().includes(query.toLowerCase())
    );
    setOptionsFilter(filtered);
  };

  const handleSelection = (selected) => {
    setSearchText(selected.length > 0 ? selected[0].name : '');
  };

  const handleSearchAction = () => {
    const input = typeaheadRef.current?.inputNode?.value;
    setSearchText(input?.trim() || '');
  };

  const resetFilter = () => {
    setSearchText('');
    navigate('/');
  };
  const filterBy = () => true;

  return (
    <div className="solo-autos">
      {showLogin && <LoginModal onClose={() => setShowLogin(false)} onSuccess={() => setShowLogin(false)} />}
      <Navbar fixed="top">
        <Container>
          <Link to="/">
            <Navbar.Brand className="d-md-none d-block">
              <img
                alt=""
                src={require("../img/logo_soloautos_min.png")}
                className="d-inline-block align-top img-fluid img-logo"
                style={{ minWidth: '43px' }}
              />
            </Navbar.Brand>
            <Navbar.Brand className="d-none d-md-block">
              <img
                alt=""
                src={require("../img/logo_soloautos.png")}
                className="d-inline-block align-top img-fluid img-logo"
                style={{ minWidth: '166px' }}
              />
            </Navbar.Brand>
          </Link>
          <InputGroup size="xl" className="campo-de-busqueda">
            <AsyncTypeahead
              ref={typeaheadRef}
              id="async-typeahead-buscar"
              isLoading={isLoading}
              labelKey="name"
              minLength={1}
              options={optionsFilter}
              onSearch={onSearching}
              filterBy={filterBy}
              onChange={handleSelection}
              useCache={false}
              placeholder="Marca o modelo..."
              promptText="Escriba para buscar"
              searchText="Buscando..."
              renderMenuItemChildren={(option) => (
                <>
                  {/* <img
                    alt={option.name}
                    src={option.image_url || 'https://via.placeholder.com/24'}
                    style={{
                      height: '24px',
                      marginRight: '10px',
                      width: '24px',
                    }}
                  /> */}
                  <span>{option.name}</span>
                </>
              )}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  handleSearchAction();
                }
              }}
            />
            <Button variant="outline-light" onClick={handleSearchAction}>
              <RiSearchLine size={20} />
            </Button>
          </InputGroup>
          <div className='div-right'>
            &nbsp;&nbsp;
            <Button variant="primary" className='d-none d-md-inline' onClick={resetFilter}>Ver Todos</Button>
            &nbsp;&nbsp;
            <Button variant="outline-primary" className='d-none d-md-inline' onClick={() => navigate('/publicar')}>
              Publicar gratis
            </Button>
            &nbsp;&nbsp;
            {user
              ? (
                <span
                  className='d-none d-md-inline'
                  style={{ cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: 8 }}
                  onClick={() => navigate('/mis-publicaciones')}
                  title="Mis publicaciones"
                >
                  {user.photoURL
                    ? <img src={user.photoURL} alt="avatar" style={{ width: 32, height: 32, borderRadius: '50%', border: '2px solid #e63a3a' }} referrerPolicy="no-referrer" />
                    : <span style={{ background: '#e63a3a', color: '#fff', borderRadius: '50%', width: 32, height: 32, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: 14 }}>
                        {(user.displayName || user.email || '?')[0].toUpperCase()}
                      </span>
                  }
                </span>
              ) : (
                <Button variant="outline-light" className='d-none d-md-inline' onClick={() => setShowLogin(true)}>
                  Iniciar sesión
                </Button>
              )
            }
            &nbsp;
            <Button variant="outline-light" className='btn-show-menu' onClick={handleShowMenu}>
              <RiMenu4Fill size={25} />
            </Button>
          </div>
        </Container>
      </Navbar>

      <Offcanvas placement="end" show={showMenu} onHide={handleCloseMenu}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <img
              alt=""
              src={require("../img/logo_soloautos.png")}
              className="d-inline-block align-top img-fluid img-logo"
              style={{ maxWidth: '166px' }}
            />
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body style={{ marginLeft: 10 }}>
          {!user && (
            <Button
              variant="outline-primary"
              style={{ width: '100%', marginBottom: 12, textAlign: 'left' }}
              onClick={() => { setShowMenu(false); setShowLogin(true); }}
            >
              Iniciar sesión
            </Button>
          )}
          <NavigationMenu setShowMenu={setShowMenu} />
          <div className="d-md-none">
            <Filters brands={filterData["brands"]} models = {filterData["brands"]}></Filters>
            <BrandsFilter brands={filterData["brands"]} />
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      {/* <Container style={{ height: '100vh' }}> */}
      <Container className="container-main">
        <Outlet />
      </Container>
    </div>

  )
};

export default Layout;
